import { motion } from "framer-motion";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { ArrowRight } from "lucide-react";
import { Image } from "@/components/ui/image";
// ✅ Import de la imagen local
import alaudaImage from "@/assets/images/alauda/alauda-eventos.jpg";

export default function AlaudaCta() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section ref={ref} className="py-20 md:py-28 px-6 lg:px-10 bg-background">
      <div className="max-w-5xl mx-auto">
        <motion.a
          href="https://www.casaelgavillero.com.mx/alauda.html"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 30 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="group flex flex-col md:flex-row items-center gap-8 md:gap-12 p-8 md:p-12 border border-border hover:border-accent/40 transition-all duration-500 bg-secondary/20 hover:bg-secondary/40 rounded-sm"
        >
          {/* Texto + flecha */}
          <div className="flex-1 flex items-center gap-5">
            <div>
              <span className="text-accent text-sm tracking-[0.3em] uppercase font-light block mb-3">
                Espacios para celebrar
              </span>
              <h3 className="font-serif-display text-3xl md:text-4xl font-light text-foreground leading-tight">
                Conoce Jardín de Eventos
              </h3>
            </div>
            <ArrowRight
              size={36}
              strokeWidth={1.5}
              className="text-accent transition-transform duration-500 group-hover:translate-x-3 flex-shrink-0"
            />
          </div>

          {/* Imagen Alauda */}
          <div className="w-32 h-32 md:w-44 md:h-44 flex-shrink-0 rounded-sm overflow-hidden border border-border">
            <Image
              src={alaudaImage}
              alt="Alauda — Jardín de Eventos"
              className="w-full h-full transition-transform duration-700 group-hover:scale-105"
              fittingType="fit"
            />
          </div>
        </motion.a>
      </div>
    </section>
  );
}